import BaseAPI from './BaseAPI';

// Read-only reports, under /reports.
class ReportsAPI extends BaseAPI {
  constructor() { super('reports'); }

  tips(start, end)        { return this.get(`/tips?start=${start}&end=${end}`); }
  receivables(start, end) { return this.get(`/receivables?start=${start}&end=${end}`); }

  // GET /reports/tip-ledger?start=&end= — earned, paid and still owed
  tipLedger(start, end) { return this.get(`/tip-ledger?start=${start}&end=${end}`); }

  // POST /reports/tip-payouts — hand over what is outstanding
  runTipPayout(payload) { return this.post('/tip-payouts', { body: payload }); }
}

export const ReportsService = new ReportsAPI();
export default ReportsAPI;
